import React from "react";
import PropTypes from "prop-types";
import Form from "../../components/Form";
import Input from "../../components/Input";
import Paper from "../../components/Paper";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Typography from "../../components/Typography";
import * as yup from "yup";
import { FORM } from "../../utils/constans";
import { makeStyles } from "../../utils/styles";
import ButtonGroup from "../../components/ButtonGroup";
import Button from "../../components/Button";
import { paths } from "../../routes";
import { useTheme } from "styled-components";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((css) => ({
    paper: css`
        position: relative;
        overflow: hidden;
        max-width: 380px;
        padding: 40px 40px 30px 40px;
        width: 100%;
    `,
    text: css`
        margin-bottom: 30px;
    `,
    input: css`
        margin: 30px 0 40px 0;
    `,
    btnSubmit: css`
        padding: 10px 45px;
    `,
    typography: css`
        line-height: 1.8em;
    `,
}));

const schema = yup.object().shape({
    email: yup.string().email(FORM.EMAIL_IS_INCORRECT).required(FORM.FIELD_IS_REQUIRED),
});

const FormForgotPassword = ({ loading, onSubmit }) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const theme = useTheme();

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schema),
    });

    return (
        <Paper customStyle={styles.paper}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Typography customStyle={styles.typography} color={theme.colors.purple} align="center" as="h2">
                    {t("Podaj adres email użyty przy rejestracji.")}
                </Typography>
                <Typography customStyle={styles.typography} color={theme.colors.purple} align="center" as="h2">
                   {t(" Wyślemy link do zmiany hasła.")}
                </Typography>
                <Input
                    type="text"
                    ref={register}
                    name="email"
                    label={t("Adres email")}
                    placeholder={t("Email")}
                    error={!!errors.email}
                    errorText={errors.email?.message}
                    customStyle={styles.input}
                />
            <ButtonGroup direction="column">
                <Button customStyle={styles.btnSubmit} type="submit" disabled={loading}>
                    {t("Resetuj hasło")}
                </Button>
                <Button customStyle={styles.btn} variant="text" to={paths.login}>
                    {t("Anuluj")}
                </Button>
            </ButtonGroup>
            </Form>
            <Loader show={loading} />
        </Paper>
    );
};

FormForgotPassword.propTypes = {
    loading: PropTypes.bool,
    onSubmit: PropTypes.func,
};


export default FormForgotPassword;
